import { BatchRecurrenceFrequency, BatchRecurrenceFrequencyDisplayName } from 'server/enums/BatchRecurrenceFrequency';
import { BatchRecurrencePeriod as ServerBatchRecurrencePeriod } from 'server/models/BatchRecurrencePeriod';

export { BatchRecurrencePeriodOptions, BatchRecurrencePeriodData } from 'server/models/BatchRecurrencePeriod';

export class BatchRecurrencePeriod extends ServerBatchRecurrencePeriod {
    toString() {
        return this.Frequency() === BatchRecurrenceFrequency.Custom ?
            this.CustomDays() + ' Days' :
            BatchRecurrenceFrequencyDisplayName[this.Frequency()];
    }
}


// WEBPACK FOOTER //
// ./data/models/BatchRecurrencePeriod.ts